import {FC, ReactElement, MouseEvent} from 'react';
import MaterialButton, {ButtonProps as MaterialButtonProps} from '@mui/material/Button';
import Spinner from './Spinner';

interface ButtonProps extends MaterialButtonProps {
  label: string;
  className?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void,
  onMouseDown?: (event: MouseEvent<HTMLButtonElement>) => void,
  type?: 'button' | 'submit' | 'reset',
  disabled?: boolean,
  fullWidth?: boolean,
  testId?: string,
  children?: Nullable<ReactElement>;
}

interface ButtonWithLoaderProps extends ButtonProps {
  isSubmitting: boolean
}

export const Button: FC<ButtonProps> = ({
  label,
  className,
  onClick=() => {},
  type = 'button',
  disabled = false,
  testId= '',
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  children,
  fullWidth = false,
  onMouseDown
}) => {
  return (
    <MaterialButton
      data-testid={testId}
      disabled={disabled}
      type={type}
      className={className}
      onClick={onClick}
      onMouseDown={onMouseDown}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
    >
      {label}
      {children}
    </MaterialButton>
  );
};

export const ButtonWithLoader: FC<ButtonWithLoaderProps> = ({
  isSubmitting, disabled, label, ...props
}) => {
  return (
    <Button label={label} disabled={disabled || isSubmitting} {...props}>
      {isSubmitting ? <Spinner embedded /> : null}
    </Button>
  );
};
